function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9273 17.1875H24.0117V19.2708H3.16797V17.1875H5.25234V9.89583C5.25234 8.38194 5.63448 6.97917 6.39875 5.6875C7.13523 4.4375 8.12878 3.44444 9.37941 2.70833C10.6717 1.94444 12.0752 1.5625 13.5898 1.5625C15.1045 1.5625 16.508 1.94444 17.8003 2.70833C19.0509 3.44444 20.0445 4.4375 20.7809 5.6875C21.5452 6.97917 21.9273 8.38194 21.9273 9.89583V17.1875ZM19.843 17.1875V9.89583C19.843 8.77083 19.5581 7.72222 18.9884 6.75C18.4325 5.80556 17.6822 5.05556 16.7373 4.5C15.7645 3.93056 14.7154 3.64583 13.5898 3.64583C12.4643 3.64583 11.4151 3.93056 10.4424 4.5C9.49752 5.05556 8.74715 5.80556 8.19131 6.75C7.62158 7.72222 7.33672 8.77083 7.33672 9.89583V17.1875H19.843ZM10.4633 21.3542H16.7164V23.4375H10.4633V21.3542Z",
  fill: "white"
});

var SvgNotifications = function SvgNotifications(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Notifications.4cb6ccc3.svg";
export { ForwardRef as ReactComponent };